/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleDailyReport = {
    properties: {
        companyId: {
    type: 'number',
    isRequired: true,
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        titles: {
    type: 'array',
    contains: {
        type: 'ScheduleDailyTitleReport',
    },
    isRequired: true,
},
        totalHours: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        census: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        ppd: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
    },
};